import * as amplitude from '@amplitude/analytics-browser';
import { AnalyticsApp, AnalyticsPlatform } from '@focuslee/shared';
import { openTelegramMiniApp } from '@focuslee/shared-mini-app';
import { AnalyticsEventType } from '../contexts/analyticsEvents';

const healthLeeMiniAppUrl = process.env.REACT_APP_HEALTHLEE_MINI_APP_URL;
const e2eHealthLeeUrl = process.env.REACT_APP_E2E_HEALTHLEE_URL ?? new URLSearchParams(window.location.search).get('e2eHealthLeeUrl');

export const trackHealthLeeCrossSellShown = (source: string) => {
    amplitude.track(AnalyticsEventType.CROSS_SELL_SHOWN, {
        target_app: AnalyticsApp.healthlee,
        source,
        app: AnalyticsApp.focuslee,
        platform: AnalyticsPlatform.telegramMiniApp,
    });
};

export const openHealthLeeMiniApp = (deepLink?: string | null, source = 'external_link') => {
    amplitude.track(AnalyticsEventType.CROSS_SELL_CLICKED, {
        target_app: AnalyticsApp.healthlee,
        source,
        app: AnalyticsApp.focuslee,
        platform: AnalyticsPlatform.telegramMiniApp,
    });
    if (e2eHealthLeeUrl) {
        const healthLeeUrl = new URL(e2eHealthLeeUrl);
        const focusLeeUrl = new URL(window.location.href);
        focusLeeUrl.searchParams.delete('e2eHealthLeeUrl');
        focusLeeUrl.searchParams.delete('e2eExternalLink');
        focusLeeUrl.hash = '';
        healthLeeUrl.searchParams.set('e2eFocusLeeUrl', focusLeeUrl.toString());
        openTelegramMiniApp(healthLeeUrl.toString(), deepLink, true);
        return;
    }
    openTelegramMiniApp(healthLeeMiniAppUrl, deepLink);
};
